import { render, staticRenderFns } from "./Payements.vue?vue&type=template&id=6062ac80"
import script from "./Payements.vue?vue&type=script&lang=js"
export * from "./Payements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports